import { Guid } from "@/lib"
import { Person } from "@/logic/workspaces/person"


export class GroupRmodel {
    name = ''
    members: Person[] = []
    uid: Guid = Guid.newGuid()
}